type GtagFnType = (...args: unknown[]) => void;

interface IGtagWindow {
  dataLayer?: unknown[];
  gtag?: GtagFnType;
}

export function getGtag(): GtagFnType | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const w = window as Window & IGtagWindow;
  if (!w.dataLayer) {
    w.dataLayer = [];
  }
  if (!w.gtag) {
    w.gtag = function gtag() {
      // biome-ignore lint/complexity/noArguments: gtag.js only executes commands pushed as an Arguments object, a rest-param array is ignored
      (w.dataLayer as unknown[]).push(arguments);
    };
  }
  return w.gtag;
}
